var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"work-list"},_vm._l((_vm.items),function(item){return _c('listItem',{key:item.uid,attrs:{"user":item,"params":_vm.params},on:{"userDetail":_vm.getUserID}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }